/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 02/10/2020
 */
const procedureSubmitNextRequest = () => {
    return {
        processId: 0,
        lastAction: null,
        data: null,
        url: ''
    }

}

export default procedureSubmitNextRequest;